import React, { useState, useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { login } from '../../firebase/app/login';

function LinkEntry({ linkId }) {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    login({ id: linkId }, (err) => {
      if (err) {
        setError(err);
      }
      setReady(true);
    });
  }, [linkId]);

  if (!ready) return null;
  if (error) return <p style={{ color: 'white', padding: 20 }}>{error}</p>;
  return <Redirect to="/app/positions" />;
}

function GuestRoute({ ...rest }) {
  return (
    <Route
      {...rest}
      render={props => <LinkEntry linkId={props.match.params.id} />}
    />
  );
}

export default GuestRoute;
